import * as types from './mutation-types';

export const setPopup = ({ commit }, data) =>
  new Promise((resolve, reject) => {
    const onResolve = state => {
      commit(types.RESET_POPUP);
      return resolve(state);
    };
    const onReject = state => {
      commit(types.RESET_POPUP);
      return reject(state);
    };
    commit(types.SET_POPUP, {
      popupType: data.popupType,
      popupResolve: onResolve,
      popupReject: onReject,
      popupData: data.popupData,
    });
  });

export const resetPopup = ({ commit }, data) =>
  new Promise((resolve, reject) => {
    commit(types.RESET_POPUP);
  });

export const sendNotification = ({ commit }, notification) => {
  commit(types.SET_NOTIFICATION, notification);
  setTimeout(() => {
    commit(types.SET_NOTIFICATION, { message: '' });
  }, notification.time || 5000);
};
